export const AlertTypeEnum = Object.freeze({
  Primary: "primary",
  Secondary: "secondary",
  Success: "success",
  Error: "danger",
  Warning: "warning",
  Info: "info",
  Light: "light",
  Dark: "dark"
});
